import { Image } from '@storyofams/storyblok-toolkit';
import { format } from 'date-fns';
import { Heading } from '../Heading';

export const WebinarHeader = ({ content }) => {
  return (
    <div className="w-full bg-gray-100 py-20 pt-28 lg:pt-32 pb-56 lg:pb-72">
      <div className="w-full max-w-6xl px-4 mx-auto flex flex-col lg:flex-row justify-between">
        <div className="w-full max-w-[614px]">
          {!!content?.kicker && (
            <Heading
              as="h6"
              variant="h6"
              className="mb-2 md:mb-6 text-gray-800"
            >
              {content?.kicker}
            </Heading>
          )}
          {!!content?.title && (
            <Heading
              as="h1"
              variant="h3"
              className="leading-[110%] !font-medium text-3xl sm:text-5xl"
            >
              {content?.title}
            </Heading>
          )}

          <div className="mt-4 lg:mt-16 text-lg font-bold text-gray-800">
            {!!content?.date &&
              format(
                new Date(content?.date?.replace(/-/g, '/')),
                'EEEE, MMMM do - H:mm',
              )}{' '}
            CET
          </div>
        </div>

        <div className="w-full aspect-[343/300] md:aspect-[442/268] overflow-hidden rounded-2xl mt-12 lg:mt-0 lg:ml-12">
          {!!content?.image?.filename && (
            <Image
              alt={content?.image?.alt || ''}
              src={content?.image?.filename}
              fit="cover"
              height="100%"
              width="100%"
              className="!object-left lg:object-center"
            />
          )}
        </div>
      </div>
    </div>
  );
};
